var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLettersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "url(#pattern0_6992_300122)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0_6992_300122",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_6992_300122",
  transform: "scale(0.0104167)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_6992_300122",
  width: 96,
  height: 96,
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAl1JREFUeAHt27FqU1EcgPF/xa24dnDTIVM62AzaSdDVB9AX8J30AYyLDipYBcWi0GRIlpslWdqhVShIB+lgOtSewIUMDdik934n4fs9QXu/c849/4SsvWi/Og9hboRQBoAZAGYAmAFgBoAZAGYAmAFgBoAZAGYAmAFgBoAZAGYAmAFgBoAZAGYAmAFgBoAZAGYAmAFgBoAZAHYzKvL86bNYJS9ft6MK7gCYAWAGgBngEn/PzqIutQVov38Xf05PI3c/j4/j7c7HqEttAdLDTxF6gyJylf62D1+/1LpQKruGztIbDGK0vx9PHj2OW+vrkYP0wD//+B6/T06ibsg7IP3Dbz7tRDEaBq0YDidHDvHwk9p3QGk8Hsdevx+/Ls7c7Xtbte+GtAh2u53JmU/CApQODg8nq6/VbEbjzt2ow/DiCOz0e7XedmbBAyRpNX7rdiersdXcrGw3pAe+29mLg6OjyEUWAUrp5ZyOpIf3H8TtjY24TiluOnJyuwpnFSBJDyhdBTcbjdjeasWi0qrvF0UWL/zLZBegVIxGk6Niketqrqt+WtYfRSwyvBFD1Tyy3QHTrjK8kUPVPJbmw7j/Gd7ooWoeS7EDSrOGt1yGqnksVYDS9PB2HmvZDFXzWMoASTm8LTu/kIEZAGYAmAFgBoAZAGYAmAFgBoAZAGYAmAFgBoAZAGYAWG3fB6zab8auizsAZgCYAWCVvQOq+l3tqnEHwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDsHyHz6dwnrWSEAAAAAElFTkSuQmCC"
}))));
export default SvgLettersIcon;